export class Search {
	static readonly type = '[brokerSearch] search';
	constructor(
		public payload: {
			searchValue: string;
			brokerageId?: string;
			cardId?: string;
		},
	) {}
}

export class Reset {
	static readonly type = '[brokerSearch] reset';
}
